import { AnimatePresence, motion } from 'motion/react'
import { Button } from 'components/Global/Button'
import { CloseIcon } from 'components/Global/CloseIcon'
import { useEffect, useState } from 'react'

export const ReviewImageOverlay = ({ image, onClose }) => {
  const [aspect, setAspect] = useState<number | null>(null)

  useEffect(() => {
    if (image) {
      const img = new Image()
      img.onload = () => {
        const aspectRatio = img.width / img.height
        setAspect(aspectRatio)
      }
      img.src = image.large
    }
  })

  return (
    <AnimatePresence mode="wait" initial>
      {image ? (
        <motion.div
          className="fixed inset-0 z-[20] flex h-full w-full items-center justify-center bg-grayTransparent p-20 backdrop-blur-lg"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Button
            onClick={onClose}
            className="absolute right-20 top-20 z-[2] bg-white md:shadow-md"
          >
            <CloseIcon className="h-12 w-12" />
          </Button>
          <AnimatePresence>
            {aspect ? (
              <motion.div
                className="relative z-[1] h-[70vh] w-auto overflow-hidden rounded-12 bg-white p-12"
                style={{ aspectRatio: aspect }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <img
                  src={image.large}
                  alt=""
                  className="h-full w-auto rounded-6"
                />
              </motion.div>
            ) : null}
          </AnimatePresence>
        </motion.div>
      ) : null}
    </AnimatePresence>
  )
}
